import getConfig from 'next/config';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import styled from 'styled-components';
// $FlowFixMe
import { Button } from '@bijie/react-bnb';

import withI18n from '../utils/withI18n';
import { getLabel } from '../utils/i18n';
import Icon from './Icon';
import FlexBox from './FlexBox';
import { getLocales } from '../utils/locales';
import { eraseCookie, createCookie } from '../utils/cookies-browser';
import { hideHeaderLangSelect } from '../actions/actionsSet/userConfig';
import { Router } from '../routes';

import {
  HeaderNavItem,
  SelectedLocale,
  HeadLink,
  LocaleMenuUp,
} from './Header/index.old';

const {
  publicRuntimeConfig: { routePrefix: ROUTE_PREFIX },
} = getConfig();

const LOCALES = getLocales();

const prefixLink = uri => ROUTE_PREFIX + uri;

const Wrap = styled.div``;

const StyledFlexbox = styled(FlexBox)`
  display: inline-block;
`;

const MainBox = styled.div`
  height: 50px;
  background: #333;
  padding: 0 35px;
  box-sizing: border-box;
  line-height: 35px;
  display: flex;
  align-content: center;
  align-items: center;
  p {
    display: inline-block;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    color: #fff;
    margin: 0;
  }
  .langDiv {
    min-width: 108px;
    height: 26px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    margin-left: 20px;
  }
  .close {
    color: #fff;
    margin-left: 40px;
    cursor: pointer;
  }
  .bnc-btn {
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    margin-left: 17px;
  }
`;

const StyleHeaderNavItem = styled(HeaderNavItem)`
  height: 26px;
  min-height: 26px;
  ul {
    height: auto;
    min-width: 250px;
    left: 0;
  }
`;

const StyleDiv = styled(FlexBox)`
  justify-content: center;
  padding: 0 10px;
  span {
    padding: 0;
  }
  img {
    transform: rotate(180deg);
  }
`;

const SelectedLocaleOpacity = styled(SelectedLocale)`
  border-color: rgba(255, 255, 255, 0.4);
  span {
    a {
      font-size: 14px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
    }
  }
  .icon-arrow-d {
    display: inline-block;
    transition: all 0.3s ease-in-out;
    margin-right: 0;
  }
  :hover {
    .icon-arrow-d {
      display: inline-block;
      transition: all 0.3s ease-in-out;
      transform: rotate(180deg);
    }
  }
`;

type Props = {
  i18n: Object,
  i18nModule: Object,
  router: Object,
  locale: string,
  locales: Object,
  isHideHeadLangSeclet: boolean,
  hideHeaderLangSelect: Function,
};

type States = {
  localeMenuPopped: boolean,
};

export default
@withI18n
@withRouter
@connect(
  null,
  { hideHeaderLangSelect }
)
class LangSelectBox extends React.Component<Props, States> {
  static defaultProps = {
    locale: 'en',
    locales: LOCALES,
    router: { asPath: '/' },
    isHideHeadLangSeclet: false,
    hideHeaderLangSelect: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      localeMenuPopped: false,
    };
  }

  _popUpLocaleMenu = bool => {
    this.setState({ localeMenuPopped: bool });
  };

  _getLocaleLink = locale => {
    const { router } = this.props;
    const matcher = /\/[a-z]{0,2}(\/|$)/;
    // does current route not contain locale? then go home
    if (!matcher.test(router.asPath)) {
      return prefixLink(`/${locale}`);
    }
    // current route contains locale, replace it
    return router.asPath.replace(matcher, `/${locale}/`).replace('//', '/');
  };

  _hideHeadLangSelect = () => {
    createCookie('isHideHeadLangSeclet', true);
    this.props.hideHeaderLangSelect(true);
  };

  _handleChange = (v: string) => {
    const href = this._getLocaleLink(v);
    Router.replaceRoute(href);
  };

  _confirmLocale = () => {
    const { locale } = this.props;
    eraseCookie('lang');
    createCookie('lang', locale.toUpperCase());
    this._hideHeadLangSelect();
  };

  render = () => {
    const {
      locales, i18n, i18nModule, isHideHeadLangSeclet, locale,
    } = this.props;
    const { localeMenuPopped } = this.state;
    if (isHideHeadLangSeclet) {
      return null;
    }
    return (
      <Wrap>
        <MainBox>
          <p>{getLabel('exchange-header-chooseLang', i18n, getLabel('exchange-header-chooseLang', i18nModule))}</p>
          <StyledFlexbox className="langFlex" justify="flex-start" align="center">
            <div className="langDiv">
              <StyleHeaderNavItem
                role="menu"
                aria-expanded={localeMenuPopped}
                onFocus={() => this._popUpLocaleMenu(true)}
                onMouseEnter={() => this._popUpLocaleMenu(true)}
                onBlur={this._popUpLocaleMenu}
              >
                <StyleDiv>
                  <SelectedLocaleOpacity justify="space-between" align="center">
                    <span>
                      <Icon type="diqiu" size={14} />
                      <HeadLink>{LOCALES[locale]}</HeadLink>
                    </span>
                    {Object.keys(locales).length > 1 && (
                      <Icon type="arrow-d" size={12} color="rgba(255,255,255,0.3)" />
                    )}
                  </SelectedLocaleOpacity>
                </StyleDiv>
                <LocaleMenuUp
                  locales={locales}
                  hide={!localeMenuPopped}
                  locale={locale}
                  onMouseLeave={this._popUpLocaleMenu}
                  getLocaleLink={this._getLocaleLink}
                  isBottomPoistion={true}
                  onChange={this._handleChange}
                />
              </StyleHeaderNavItem>
            </div>
          </StyledFlexbox>
          <Button type="primary" onClick={this._confirmLocale}>
            {getLabel('exchange-common-continue', i18n, getLabel('exchange-common-continue', i18nModule))}
          </Button>
          <span className="close">
            <Icon type="close-strong" onClick={this._hideHeadLangSelect} />
          </span>
        </MainBox>
      </Wrap>
    );
  };
}
